module.exports = __webpack_public_path__ + "img/Published.60089ec5-p-130x130q80.c22db3ba.png";